import { Navigate, Outlet } from "react-router-dom";

const PrivateRouteUser = () => {
  const auth = JSON.parse(localStorage.getItem("auth")); // Get auth data from localStorage
  const token = auth?.token; // Extract token

  if (!token) {
    return <Navigate to="/sign_in" replace />;
  }

  try {
    // Decode the JWT token
    const tokenParts = token.split(".");
    if (tokenParts.length !== 3) {
      throw new Error("Invalid token format");
    }

    const payload = JSON.parse(atob(tokenParts[1])); // Decode payload
    const expiry = payload.exp; // Extract expiry time

    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
    if (expiry && expiry < currentTime) {
      localStorage.removeItem("auth"); // Remove expired token
      return <Navigate to="/sign_in" replace />;
    }
  } catch (error) {
    console.error("Token decoding error:", error);
    localStorage.removeItem("auth");
    return <Navigate to="/sign_in" replace />;
  }

  return <Outlet />;
};

export default PrivateRouteUser;